/*
  GA4マイクロイベント（2026-09-09・クライアント要望）

  計測タグ自体はここでは読まない。Google & YouTube アプリが本体ドキュメントに
  gtag.js（G-RE893B9F7R / GT-5DDGZRJK）を入れており、window.gtag がそのまま使える。
  ここは「アプリが送らないイベントだけ」を後乗せするファイル。
  同じ gtag に乗るので client_id / session_id はアプリ計測と同じ＝同一ユーザーとして繋がる。

  絶対にやらないこと（2026-08-27の二重計上の再発防止）:
    - page_view / view_item / add_to_cart / begin_checkout / purchase など標準イベントを送る
    - fbq / clarity をここから呼ぶ

  送るイベント:
    pdp_engaged     商品ページ滞在 30/60/120秒（表示中のみ加算）
    line_cta_click  LINE導線のタップ（placement で箇所を分ける）
    instagram_click Instagramリンクのタップ（placement で箇所を分ける）
    video_open      着用動画の拡大モーダルを開いた
    video_progress  拡大再生の 25/50/75% 通過
    video_complete  拡大再生の初回ループ完走
*/
(function () {
  'use strict';

  var tag = document.querySelector('script[data-sk-events]');
  var GA4_ID = (tag && tag.getAttribute('data-ga4-id')) || '';

  var main = document.querySelector('main[data-template]');
  var TEMPLATE = (main && main.dataset.template) || '';

  function send(name, params) {
    if (typeof window.gtag !== 'function') return;
    var payload = params || {};
    /* 測定IDが取れているときだけ宛先を絞る。空なら設定済みの全ターゲットへ */
    if (GA4_ID) payload.send_to = GA4_ID;
    window.gtag('event', name, payload);
  }

  function merge(a, b) {
    var out = {};
    var k;
    for (k in a) if (Object.prototype.hasOwnProperty.call(a, k)) out[k] = a[k];
    for (k in b) if (Object.prototype.hasOwnProperty.call(b, k)) out[k] = b[k];
    return out;
  }

  /* 商品ページの商品。Shopifyが content_for_header で入れる meta を使う（テーマ側に埋め込まない） */
  function productContext() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var id = null;
    if (meta) {
      if (meta.product && meta.product.id) id = meta.product.id;
      else if (meta.page && meta.page.resourceId) id = meta.page.resourceId;
    }
    var og = document.querySelector('meta[property="og:title"]');
    var ctx = {};
    if (id) ctx.item_id = String(id);
    ctx.item_name = og ? og.content : document.title;
    return ctx;
  }

  function closest(el, selector) {
    if (!el || !el.closest) return null;
    return el.closest(selector);
  }

  /* ---- 1. 商品ページ滞在時間 ------------------------------------------- */

  function initDwell() {
    if (TEMPLATE !== 'product') return;

    var thresholds = [30, 60, 120];
    var ctx = productContext();
    var seconds = 0;
    var next = 0;

    var timer = setInterval(function () {
      /* タブが裏・別アプリのときは加算しない。「見ていた時間」に寄せる */
      if (document.hidden) return;
      seconds += 1;
      while (next < thresholds.length && seconds >= thresholds[next]) {
        send('pdp_engaged', merge(ctx, { engaged_seconds: thresholds[next] }));
        next += 1;
      }
      if (next >= thresholds.length) clearInterval(timer);
    }, 1000);
  }

  /* ---- 2. LINE導線 / 4. Instagram導線 ----------------------------------- */

  function linePlacement(a) {
    if (closest(a, '.sk-line-float__bubble')) return 'float_bubble'; /* 右下ポップアップの吹き出し */
    if (closest(a, '.sk-line-float')) return 'float_btn'; /* 右下の丸ボタン */
    if (closest(a, '.sk-drawer')) return 'drawer'; /* SPメニュー内バナー */
    if (closest(a, '.sk-sidebar')) return 'sidebar'; /* PC左サイドバーのバナー */
    if (closest(a, '.sk-cart')) return 'cart'; /* カート内「LINEで相談」 */
    if (closest(a, 'footer')) return 'footer';
    return 'other';
  }

  function igPlacement(a) {
    if (closest(a, '.sk-igg')) return 'ig_grid'; /* トップの投稿グリッド */
    if (closest(a, '.sk-instagram')) return 'reels'; /* リール横スクロール */
    if (closest(a, '.sk-sidebar__banner')) return 'sidebar_banner';
    if (closest(a, '.sk-sidebar')) return 'sidebar_icon';
    if (closest(a, '.sk-drawer')) return 'drawer_icon';
    if (closest(a, 'footer')) return 'footer_icon';
    return 'other';
  }

  function initOutbound() {
    document.addEventListener(
      'click',
      function (ev) {
        var target = ev.target;
        if (!target || target.nodeType !== 1) return;
        var a = closest(target, 'a[href]');
        if (!a) return;
        var href = a.getAttribute('href') || '';

        if (href.indexOf('lin.ee') !== -1 || href.indexOf('line.me') !== -1) {
          send('line_cta_click', { placement: linePlacement(a), page_type: TEMPLATE });
          return;
        }
        if (href.indexOf('instagram.com') !== -1) {
          send('instagram_click', {
            placement: igPlacement(a),
            page_type: TEMPLATE,
            link_url: a.href
          });
        }
      },
      true
    );
  }

  /* ---- 3. 着用動画 ------------------------------------------------------ */

  /*
    一覧のサムネは autoplay/muted/loop で勝手に再生されるので「視聴」に数えない。
    数えるのは、タップして拡大モーダルで再生したぶんだけ。
    視聴率 = video_open ÷ view_item（アプリ計測）、完了率 = video_complete ÷ video_open。
  */
  function watchVideo(video, meta) {
    var fired = {};
    var done = false;

    video.addEventListener('timeupdate', function () {
      if (done) return;
      var duration = video.duration;
      if (!duration || !isFinite(duration)) return;
      var percent = (video.currentTime / duration) * 100;

      var marks = [25, 50, 75];
      for (var i = 0; i < marks.length; i += 1) {
        if (percent >= marks[i] && !fired[marks[i]]) {
          fired[marks[i]] = true;
          send('video_progress', merge(meta, { percent: marks[i] }));
        }
      }
      /* loop なので初回の完走だけ拾う */
      if (percent >= 95) {
        done = true;
        send('video_complete', meta);
      }
    });
  }

  function initMovie() {
    var body = document.querySelector('[data-sk-movie-body]');
    if (!body) return;

    var current = {};

    document.addEventListener('click', function (ev) {
      var target = ev.target;
      if (!target || target.nodeType !== 1) return;
      var item = closest(target, '[data-sk-movie]');
      if (!item) return;

      var caption = item.querySelector('.sk-movie__caption');
      current = merge(productContext(), {
        video_id: item.getAttribute('data-sk-movie'),
        video_title: caption ? caption.textContent.trim() : ''
      });
      send('video_open', current);
    });

    /* モーダルの中身は開いた瞬間にtemplateから差し込まれる。生えたvideoに後から付ける */
    var observer = new MutationObserver(function () {
      var video = body.querySelector('video');
      if (video && !video.dataset.skTracked) {
        video.dataset.skTracked = '1';
        watchVideo(video, current);
      }
    });
    observer.observe(body, { childList: true, subtree: true });
  }

  initDwell();
  initOutbound();
  initMovie();
})();
